
<div>

  <div class="submission-details">
    <div class="container">
      <div :class="showActions ? 'row' : ''">
        <div :class="pageTitleClass">
          <suffix v-if="$feature.isOn('see_underlying_properties')" >
            <button class="btn-icon blue" @click="showSeeUnderlyingPropertiesModal">
              <icon class="inspection"></icon>
              <span class="sr-only">See Underling Properties</span>
            </button>
          </suffix>
          <underlying-properties-modal
            @toggle-modal="hideModal(vueModalID.seeUnderlyingProperties)"
            :object-model-entry="selectedObjectModelEntry"
            :object-model="selectedDetailView.objectModel"
            v-if="modalStateFor(vueModalID.seeUnderlyingProperties).isVisible"
            :state="modalStateFor(vueModalID.seeUnderlyingProperties)"
            :index="vueModalID.seeUnderlyingProperties"
          ></underlying-properties-modal>
          <detail-view-content-element-base
            :content-element="pageTitleElement"
            :object-model-entry="entry"
          ></detail-view-content-element-base>
        </div>
        <div class="col-12 col-md-3" v-if="showActions">
          <detail-view-content-element-base
            :content-element="actionsElement"
            :is-in-edit-mode="isInEditMode"
            :object-model-entry="entry"
          ></detail-view-content-element-base>
        </div>

      </div>
      <div>
        <detail-view-content-element-base v-if="pageSubTitleElement.label_title"
                                          :content-element="pageSubTitleElement"
                                          :object-model-entry="entry"
        ></detail-view-content-element-base>
      </div>
      <div v-for="modelProperty in additionalPropertyElements" class="inline-parent">
        <detail-view-content-element-base
          :content-element="modelProperty"
          :object-model-entry="entry"
        ></detail-view-content-element-base>
      </div>

      <tab-container
        v-if="hasTabs"
        :is-in-edit-mode="isInEditMode"
      ></tab-container>
      <a v-if="showReturnToDetailViewLink" :href="returnToDetailViewLink" class="btn-link">
        <icon glyph="arrow-chevron" direction="left" tag="small" aria-hidden="true"></icon>
        Return
      </a>
    </div>
  </div>
</div>
